// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.video-js.vjs-fluid,\r\n.video-js.vjs-16-9,\r\n.video-js.vjs-4-3 {\r\n  height: 100% !important;\r\n  padding-top: 0 !important;\r\n  width: 100% !important;\n}\n.vjs-tech {\r\n  width: 100% !important;\r\n  height: 100% !important;\n}\n.vjs-poster {\r\n  background-position: center !important;\r\n  background-size: cover !important;\n}\nvideo {\r\n  width: calc(100% - 0px) !important;\r\n  height: calc(100% - 0px) !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
